<template>
  <v-app id="inspire">
    <v-content>
      <router-view />
    </v-content>
    <loading />
    <snackbar />
  </v-app>
</template>
<script>
import loading from "./components/Loading";
import snackbar from "./components/snackbar";
import axiosInterceptor from './tools/axiosInterceptor'
import { host, getPublicIP } from './tools'
export default {
  name: "App",
  components: {
    loading,
    snackbar,
  },
  async created() {
    host();
    await getPublicIP();
    axiosInterceptor();
  },
};
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.v-stepper__label {
  font-size: 11px !important;
  text-align: center !important;
}
</style>
